import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { Section } from '@/components/subscription/lp/section'
import { Modal } from '@/components/subscription/lp/modal'
import { styles } from './styles.css'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import caret from './images/caret.svg'

export const HowtoSection: React.FC = () => {
  return (
    <Section id="howto" title="HOWTO" subtitle="お届けから飾るまで" className={styles.section}>
      <Flex direction="column" align="center" justify="start" width="100%" gap="48px" px="24px" className={styles.content}>
        <Flex direction="row" align="center" justify="center" maxWidth="392px" gap="24px">
          <p className={styles.text}>毎回ブーケを宅急便でご自宅までお届け。毎回発送前にメールにてご連絡いたします。</p>
          <img className={styles.image1} src={image1} />
        </Flex>
        <Flex direction="row" align="center" justify="center" maxWidth="392px" gap="24px">
          <img className={styles.image2} src={image2} />
          <Flex direction="column" align="start" justify="between" maxWidth="392px" gap="16px" pt="24px">
            <p className={styles.text2}>届いたらまず、水をたっぷり吸わせる”水揚げ”をしてあげましょう！このひと手間でお花が長持ち。</p>
            <Modal
              title="基本の水揚げ方法"
              renderTrigger={() => (
                <button className={styles.button} type="button">
                  基本の水揚げ方法
                  <img src={caret} className={styles.caret} />
                </button>
              )}
              renderContent={() => (
                <Flex direction="column" align="start" justify="start" gap="24px" mb="40px" width="100%">
                  <video controls style={{ aspectRatio: '2160 / 3840' }}>
                    <source
                      type="video/mp4"
                      src="https://flower-production-assets.s3.ap-northeast-1.amazonaws.com/uploads/article_media/production/file/15/7ac45e0c-6fab-4930-b270-2ce78c331dad.mp4#t=0.0001"
                    />
                  </video>
                  <h3 className={styles.dialogHeading1}>
                    お花の持ちがぐんとよくなる、
                    <wbr />
                    基本の水揚げ方法。
                  </h3>
                  <p className={styles.dialogDescription}>お花が届いたら、花器に活ける前にまず「水揚げ」。これでお花の持ちがぐんとよくなりますよ😉</p>
                  <Flex direction="column" align="start" justify="start" gap="12px" width="100%">
                    <h4 className={styles.dialogHeading2}>なぜ水揚げをするの？</h4>
                    <p className={styles.dialogDescription}>
                      農家さんから届いたお花は一時的にお水から離され仮死状態に。水揚げは、そんなお花を生き返らせる大切な作業なんです。
                    </p>
                  </Flex>
                  <Flex direction="column" align="start" justify="start" gap="12px" width="100%">
                    <h4 className={styles.dialogHeading2}>水揚げのポイント</h4>
                    <ol className={styles.dialogBullet}>
                      <li>茎先を水の中でカット</li>
                      <li>花が上を向くようにしっかり紙で巻く</li>
                      <li>茎が8割ほど浸かるイメージで、たっぷり深めの水に入れる</li>
                    </ol>
                  </Flex>
                  <p className={styles.dialogDescription}>詳しいやり方は動画でチェック👀</p>
                </Flex>
              )}
            />
          </Flex>
        </Flex>
        <Flex direction="column" align="center" justify="start" maxWidth="392px" gap="20px">
          <p className={styles.text3}>お花が水を十分吸ったら、あとは飾るだけ。お気に入りの花器に活けてお花を楽しんで！</p>
          <img className={styles.image3} src={image3} />
        </Flex>
      </Flex>
    </Section>
  )
}
